import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Reveal, Overline } from "@/components/Reveal";

export default function Shop() {
    const [products, setProducts] = useState([]);
    const [active, setActive] = useState("All");

    useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);

    const categories = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
    const shown = active === "All" ? products : products.filter((p) => p.category === active);

    return (
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
            <Reveal>
                <Overline>The Apothecary</Overline>
                <h1 className="mt-3 font-serif text-5xl sm:text-6xl text-cream">Rootwork Supplies</h1>
                <p className="mt-4 text-ash max-w-xl">Hand-poured candles, dressed oils, herb blends, mojos, and spell kits, made and fixed by Sherrie.</p>
            </Reveal>

            <div className="mt-10 flex flex-wrap gap-2.5" data-testid="shop-filters">
                {categories.map((c) => (
                    <button key={c} onClick={() => setActive(c)} data-testid={`filter-${c}`}
                        className={`px-4 py-2 rounded-full text-sm border transition-colors ${active === c ? "bg-gold text-ink border-gold" : "border-gold/25 text-ash hover:text-gold hover:border-gold/50"}`}>
                        {c}
                    </button>
                ))}
            </div>

            <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-6" data-testid="shop-grid">
                {shown.map((p, i) => <Reveal key={p.id} delay={(i % 4) * 0.05}><ProductCard product={p} /></Reveal>)}
            </div>
            {shown.length === 0 && <p className="text-ash mt-16 text-center">Nothing here yet.</p>}
        </div>
    );
}
